"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const actions_1 = require("../../../../actions");
const reducers_1 = require("../../../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const EventPredicateAddEdit_1 = require("./EventPredicateAddEdit");
const react_redux_1 = require("react-redux");
const EventAddCondition = ({ device, predicate, }) => !!predicate && (React.createElement("div", null,
    React.createElement(EventPredicateAddEdit_1.default, { device: device, type: "add" },
        React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    height: 24,
                    width: 4,
                    background: src_1.quartz,
                    marginLeft: 24,
                } }),
            React.createElement("div", { style: {
                    width: 148,
                    height: 24,
                    display: 'flex',
                    alignItems: 'center',
                } },
                React.createElement("div", { style: {
                        width: 24,
                        height: 24,
                        borderRadius: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: src_1.turquoise,
                        marginRight: 8,
                        marginLeft: 14,
                    } },
                    React.createElement(src_1.PlusIcon, { fill: src_1.white })),
                React.createElement(src_1.Button, { text: "Add condition", mouseDownColors: {
                        active: src_1.turquoise,
                        inactive: src_1.aquamarine,
                    }, preventDefault: false, type: "regular" }))))));
const mapStateToProps = (state) => ({
    predicate: reducers_1.getEditableEventAttributesEventTriggerFilter(state),
});
const mapDispatchToProps = (dispatch) => ({
    updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EventAddCondition);
